const initialState = {
  presetName: 'default'
}

const user = (state = initialState, action) => {
  switch (action.type) {
    case 'APPLY_PRESET_NAME': {
      return {...state, presetName: action.payload }
    }
    default: {
      return state
    }
  }
}

export default user
